export default __webpack_public_path__ + "assets/senegal-flag.png";